import { useState, useEffect } from 'react';
import filter from 'lodash/filter';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import isMatchWith from 'lodash/isMatchWith';
import union from 'lodash/union';
import reduce from 'lodash/reduce';
import { useStore } from './useStore';
// import useBackendSync from './useBackendSync';

const usePackages = () => {
  const [state, dispatch] = useStore();
  // const { postUpdate } = useBackendSync();
  const { clientState, fares } = state;
 
  /**
   * Transfer quantities to/from adult/child to/from package
   * @param {String} action add/subtract
   */
  const convertPackage = (action) => {
    console.log('convertPackage');
    const qty = clientState.tq;
    console.log('qty', qty);
    const adultTix = find(qty, ['id', 'adult']);
    const childTix = find(qty, ['id', 'child']);
    const adultPackageTix = find(qty, ['id', 'adult_package']);
    const childPackageTix = find(qty, ['id', 'child_package']);
    if (action === 'add') {
      if (adultTix.quantity > 0) {
        adultTix.quantity--;
        adultPackageTix.quantity++;
      } else if (childTix.quantity > 0) {
        childTix.quantity--;
        childPackageTix.quantity++;
      }
    } else {
      if (adultPackageTix.quantity > 0) adultPackageTix--;
      else if (childPackageTix.quantity > 0) childPackageTix--;
    }
    return qty;
  }

  /**
   * Transfer quantities to/from regular gift tickets to/from gift box tickets
   * @param {String} action add/subtract
   */
  const convertGiftBox = (action) => {
    console.log('convertGiftBox');
    const qty = clientState.tq;
    const regular = filter(qty, (s) => !s.id.includes('box') );
    const box = filter(qty, (s) => s.id.includes('box') );
    if (action === 'add') {
      return qty.map(q => {
        const baseID = q.id.replace('_box', '');
        if (q.id.includes('box')) return q.quantity = regular[baseID].quantity;
        else return q.quantity = 0;
      });
    }
    return qty.map(q => {
      const baseID = q.id.replace('_box', '');
      if (q.id.includes('box')) return q.quantity = 0;
      else return q.quantity = box[baseID+'_box'].quantity;
    });
  }

  /**
   * Finds individual tickets to convert to a package
   * @returns Object of matched package
   */
  const convertSingles = (quantities) => {
    console.log('convertSingles', quantities);
    const match = findPackageMatch(quantities);
    if (match) {
      setSavings(match);
            
      let newQuantities = quantities.map(q => {
        if (q.id === match.replaceWith) q.quantity += 1;
        return q;
      });
      forEach(match.deduct, (q) => {
        const item = find(newQuantities, ['id', q.id]);
        item.quantity -= q.quantity;
      });
      // console.log('newQuantities', newQuantities);
      // console.log('clientState', clientState);
      // postUpdate();
    }
  }
  const findPackageMatch = (quantities) => {
    console.log('findPackageMatch');
    let ticketMatch = null;
    const tix = filter(quantities, (s) => { return s.quantity > 0 });
    // console.log('TICKETS', tickets);
    forEach(packages, function(v, k) {
      const ticketsToMatch = v.filter(item => {
        return tix.some(s => {
          return item.id === s.id && s.quantity >= item.quantity;
        })
      });
      const match = isMatchWith(ticketsToMatch, v, hasMin);
      if (match) {
        ticketMatch = {
          replaceWith: k,
          deduct: v
        };
        return false;
      }
    });
    return ticketMatch;
  }
  const setSavings = (match) => {
    const newPrice = find(fares, ['id', match.replaceWith]);
    console.log('newPrice', newPrice.price);
    const oldPrice = reduce(match.deduct, (acc, cur) => {
      const tix = find(fares, o => o.id === cur.id);
      const subTotalPrice = parseFloat(tix.price) * parseInt(cur.quantity);
      return acc + subTotalPrice;
    }, 0);
    const savings = oldPrice - newPrice.price;
    dispatch('SET', {
      showSavingsMesssage: true,
      savings: {
        package: match.replaceWith,
        cost: savings
      }
    })
  }

  /**
   * Transfer quantities to/from regular tickets to/from group tickets
   * @param {String} action add/subtract
   */
   const convertGroup = (action) => {
    //  console.log('convertGroup');
    const qty = clientState.tq;
    const adultTix = find(qty, ['id', 'adult']);
    const childTix = find(qty, ['id', 'child']);
    const adultGroupTix = find(qty, ['id', 'group_adult']);
    const childGroupTix = find(qty, ['id', 'group_child']);
    if (action === 'add') {
      // console.log('ADD GROUP');
      adultGroupTix.quantity = adultTix.quantity;
      childGroupTix.quantity = childTix.quantity;
      adultTix.quantity = 0;
      childTix.quantity = 0;
    } else if (action === 'subtract') {
      adultTix.quantity = adultGroupTix.quantity;
      childTix.quantity = childGroupTix.quantity;
      adultGroupTix.quantity = 0;
      childGroupTix.quantity = 0;
    }
    return qty;
  }

  return {
    convertSingles,
    convertPackage,
    convertGiftBox,
    convertGroup
  }
}

function hasMin(firstObjValue, secondObjValue) {
  return firstObjValue.id === secondObjValue.id && firstObjValue.quantity >= secondObjValue.quantity;
}

const packages = {
  adult_package: [
    {
      id: 'adult',
      quantity: 1
    },
    {
      id: 'guidebook',
      quantity: 1
    },
    {
      id: 'digital_guidebook',
      quantity: 1
    }
  ],
  child_package: [
    {
      id: 'child',
      quantity: 1
    },
    {
      id: 'guidebook',
      quantity: 1
    },
    {
      id: 'digital_guidebook',
      quantity: 1
    }
  ],
  family_2_2: [
    {
      id: 'adult',
      quantity: 2
    },
    {
      id: 'child',
      quantity: 2
    }
  ],
  family_2_2_gift: [
    {
      id: 'adult_gift',
      quantity: 2
    },
    {
      id: 'child_gift',
      quantity: 2
    }
  ],
  family_1_3: [
    {
      id: 'adult',
      quantity: 1
    },
    {
      id: 'child',
      quantity: 3
    }
  ],
  family_1_3_gift: [
    {
      id: 'adult_gift',
      quantity: 1
    },
    {
      id: 'child_gift',
      quantity: 3
    }
  ]
};

export default usePackages;